import { makeAutoObservable } from "mobx";
import {
  CryptoRecord,
  CurrencyMap,
  Result,
  TradesMap,
} from "../types/types";

class PresaleStore {
  alfaValue: any | null = null;
  cryptoValue: any | null = null;
  cryptoList: CurrencyMap = {
    "USDT (ERC20)": "ERC20",
    "USDT (TRC20)": "TRC20",
    "BTC (Bitcoin)": "Bitcoin",
    "ETH (Ethereum)": "Ethereum",
    "ALGO (Algorand)": "Algorand",
    "XRP (Ripple)": "Ripple",
    "TON (Toncoin)": "Toncoin",
  };
  selectedCrypto: { name: string; value: string } | null = null;
  selectedAlfa: { name: string; value: string } | null = null;
  captchaToken: string | null = null;
  isPaid: Number | undefined = undefined;
  dataValid: boolean | undefined = false;
  isClickBuy: boolean | undefined = false;
  result: Result = {
    name: "",
    crypto_count: 0,
    alfa_count: 0,
  };
  buyInfo: CryptoRecord = {
    id: 0,
    name: "",
    crypto_count: 0,
    alfa_count: 0,
    user_id: 0,
    timestamp: "",
    address_dest: "",
    qr_code: "",
    debt: ""
  };
  buyInfoId: Number = 0;
  lastTransactions: TradesMap = {};
  purchaseUrl: string | null = null;

  constructor() {
    makeAutoObservable(this);
    const savedBuyInfoId = sessionStorage.getItem("buyInfoId");
    const isPresaleRoute = window.location.pathname.startsWith("/presale/");
    if (savedBuyInfoId && isPresaleRoute) {
      this.buyInfoId = Number(savedBuyInfoId);
      this.sendDataPresaleById();
    }
  }
  setAlfaValue(value: any | 0) {
    this.alfaValue = value;
  }
  setCryptoValue(value: any | 0) {
    this.cryptoValue = value;
  }
  setResult(name: string, crypto_count: number, alfa_count: number) {
    this.result.alfa_count = alfa_count;
    this.result.crypto_count = crypto_count;
    this.result.name = name;
  }
  setBuyInfoId(id: number) {
    this.buyInfoId = id;
    sessionStorage.setItem("buyInfoId", id.toString());
  }

  async getCryptoList() {
    try {
      const res = await fetch("/api/v1/presale/list", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      this.cryptoList = await res.json();
    } catch (error) {
      console.error("Ошибка при выполнении fetch-запроса rate:");
    }
  }

  async getCourseAlfa() {
    try {
      const res = await fetch(
        "/api/v1/presale/get/alfa",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.selectedCrypto),
        }
      );
      const data = await res.json();
      this.alfaValue = data.value;
    } catch (error) {
      console.error("Ошибка при выполнении fetch-запроса rate:");
    }
  }

  async getCourseCrypto() {
    try {
      const res = await fetch(
        "/api/v1/presale/get/crypto",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.selectedAlfa),
        }
      );
      const data = await res.json();
      this.cryptoValue = data.value;
    } catch (error) {
      console.error("Ошибка при выполнении fetch-запроса rate:");
    }
  }

  async sendDataPresale() {
    try {
      const res = await fetch("/api/v1/presale/buy", {
        method: "POST",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(this.result),
      });

      if (!res.ok) {
        throw new Error(`Ошибка при запросе: ${res.status}`);
      }

      const data = await res.json();
      this.buyInfo = data;
      this.setBuyInfoId(this.buyInfo.id);
    } catch (error) {
      console.error("Ошибка при выполнении fetch-запроса rate:", error);
    }
  }

  async getDataExchnagePresale() {
    try {
      const res = await fetch("/api/v1" + this.purchaseUrl, {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) {
        throw new Error(`Ошибка при запросе: ${res.status}`);
      }

      const data = await res.json();
      this.buyInfo = data;
      this.setBuyInfoId(this.buyInfo.id);
    } catch (error) {
      console.error("Ошибка при выполнении fetch-запроса rate:", error);
    }
  }

  async sendDataPresaleById() {
    try {
      const res = await fetch(
        "/api/v1/presale/purchase/info",
        {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: this.buyInfoId }),
        }
      );

      if (!res.ok) {
        throw new Error(`Ошибка при запросе: ${res.status}`);
      }

      const data = await res.json();
      this.buyInfo = data;
      this.setBuyInfoId(this.buyInfo.id);
    } catch (error) {
      console.error("Ошибка при выполнении fetch-запроса rate:", error);
    }
  }

  async getLastTransactions() {
    try {
      const res = await fetch(
        "/api/v1/user/purchases",
        {
          method: "GET",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (!res.ok) {
        throw new Error(`Ошибка при запросе: ${res.status}`);
      }

      const data = await res.json();
      this.lastTransactions = data;
      this.setBuyInfoId(this.buyInfo.id);
    } catch (error) {
      console.error("Ошибка при выполнении fetch-запроса rate:", error);
    }
  }

  setCaptchaToken(value: string | null) {
    this.captchaToken = value;
  }

  setIsPaid(component: Number | undefined) {
    this.isPaid = component;
  }

  setDataValid(component: boolean | undefined) {
    this.dataValid = component;
  }

  setClickBuy(component: boolean | undefined) {
    this.isClickBuy = component;
  }

  setPurchaseUrl(component: string | null) {
    this.purchaseUrl = component;
  }
}

const presaleStore = new PresaleStore();
export default presaleStore;
